import $ from "jquery";

class TimeNotifications {
    // Initiate object
    constructor (){
        // Saturday & sunday are closed
        this.closedDays = wemake.closed_days;
        this.holidays = JSON.parse(wemake.holidays);
        this.openingtimes = JSON.parse(wemake.openingstijden);
        this.holidayDates = [];
        this.todayDate;
        this.time;
        this.tomorrowDate; 
        this.initTimeVariables();
        this.breakStartTime = JSON.parse(wemake.pauze_start_tijd);
        this.breakEndTime = JSON.parse(wemake.pauze_eind_tijd);
    }


    // Methods
    initTimeVariables(){
        if (this.holidays){
            this.holidays.forEach((holiday) => {
                this.holidayDates.push(holiday.dag);
            });
        }
    
        this.todayDate = new Date();

        let hours = (this.todayDate.getHours() < 10 ? '0' : '') + this.todayDate.getHours();
        let minutes = (this.todayDate.getMinutes() < 10 ? '0' : '') + this.todayDate.getMinutes();
        this.time = hours + ':' + minutes;

        this.tomorrowDate = new Date(this.todayDate);
        this.tomorrowDate.setDate(this.todayDate.getDate() + 1);
    }

    setPickupNotificationText(element){
        let notification = $(element);   
        if (notification.length == 0){
            return;
        }

        let todayOpeningTime = this.openingtimes[this.todayDate.getDay()].openingstijd; 
        let todayClosingTime = this.openingtimes[this.todayDate.getDay()].sluitingstijd;
        
        let nextOpenDay = this.getNextOpenDay(this.tomorrowDate).getTime() == this.tomorrowDate.getTime() ? 'Morgen' : this.openingtimes[this.getNextOpenDay(this.tomorrowDate).getDay()].dag;
        let nextOpenDayOpeningTime = this.openingtimes[this.getNextOpenDay(this.tomorrowDate).getDay()].openingstijd;

        let beforeOpenText = notification.data('before');
        let openText = notification.data('open');
        let tomorrowOpenText = notification.data('after');
        let closedText = notification.data('closed');
        
        // Free days are holidays & sundays

        // 3 possible times during a day, before opening, open, after closing.
        // After closing
        if (this.time > todayClosingTime){
            // Two possible things, store is open tomorrow or not open tomorrow
            // So if tomorrow is a holiday, or closed
            if (this.isClosedDay(this.tomorrowDate)){
                notification.text(closedText.replace('{dag}', nextOpenDay).replace('{openingstijd}', nextOpenDayOpeningTime));
            }
            else{
                notification.text(tomorrowOpenText.replace('{dag}', nextOpenDay).replace('{openingstijd}', nextOpenDayOpeningTime))
            }
        }
        // Before opening 
        else if (this.time < todayOpeningTime){
            // Two possibilities, store is open today, or not
            if (this.isClosedDay(this.todayDate)){
                notification.text(closedText.replace('{dag}', nextOpenDay).replace('{openingstijd}', nextOpenDayOpeningTime));
            }
            // If the store is open today
            else{
                notification.text(beforeOpenText.replace('{openingstijd}', todayOpeningTime));
            }     
        }
        // Inside of a break period
        else if (this.time >= this.breakStartTime && this.time <= this.breakEndTime){
            notification.text(beforeOpenText.replace('{openingstijd}', this.breakEndTime));
        }
        // Store is open (timewise)
        else{
            // Two possibilities, store is open today, or not
            if (this.isClosedDay(this.todayDate)){
                notification.text(closedText.replace('{dag}', nextOpenDay).replace('{openingstijd}', nextOpenDayOpeningTime));
            }
            else{
                notification.addClass('open');
                notification.text(openText.replace('{sluitingstijd}', todayClosingTime));
            }
        }
    }

    // Give a closed day, find the next open day based on the closed days & holidays
    getNextOpenDay(date){

        // Find the next open day
        let nextDay = new Date(date);

        while (this.isClosedDay(nextDay)) {
            nextDay.setDate(nextDay.getDate() + 1);
        }

        return nextDay;
    }

    // Accepts date object
    isClosedDay(date) {
        const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)
        const dateString = this.getFormattedDate(date);
        return this.closedDays.includes(dayOfWeek) || this.holidayDates.includes(dateString);
    }


    getFormattedDate(date){
        // Get day, month, and year
        var day = date.getDate();
        var month = date.getMonth() + 1; // Month starts from 0
        var year = date.getFullYear();

        // Format day and month to have leading zeros if necessary
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return day + '/' + month + '/' + year.toString();
    }

}

export default TimeNotifications
